module.exports = __webpack_public_path__ + "media/styles/images/svg/comment-gray-dark-bb4211e5766d9b8485805ef4833740e0.svg";